import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { Box, Drawer, Grid, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from '../../../store';
import { closeDrawer, IBankEditState } from '../../../store/bank/bank-edit-slice';
import { RootState } from '../../../store/reducers';
import CreateForm from './form';

const BankDrawer = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { isDrawerOpen, isEditMode, currentBank }: IBankEditState = useSelector((state: RootState) => state.bankEdit);

    const handleClose = () => {
        dispatch(closeDrawer());
    };

    return (
        <Drawer anchor="right" open={isDrawerOpen} onClose={handleClose}>
            <Grid p={2} container justifyContent={'space-between'}>
                <Grid item flexGrow={1}>
                    <Typography component="span" variant="h6">
                        {isEditMode ? `Modifica banca ${currentBank?.bankName}` : 'Crea Nuova banca'}
                    </Typography>
                </Grid>
                <Grid item>
                    <IconButton onClick={() => handleClose()} sx={{ width: '30px', height: '30px' }}>
                        <CloseOutlined />
                    </IconButton>
                </Grid>
            </Grid>
            <Box p={2} sx={{ minWidth: '360px', width: '40vw' }}>
                <CreateForm isEditMode={isEditMode} bank={currentBank} />
            </Box>
        </Drawer>
    );
};

export default BankDrawer;
